import { redirect } from '@sveltejs/kit';
import { auth } from '$lib/auth.svelte';
import { fetchDojo } from '$lib/api/dojo';
import type { LayoutLoad } from './$types';

export const ssr = false;
export const prerender = false;

// `/login` (and its sub-routes) must work without auth. Everything else needs
// a token before we even try to fetch the dojo schema bundle — without this
// guard, the layout's dojo fetch would 401 and bounce, which is fine but
// noisy. With the guard, the redirect happens up front.
const PUBLIC_PATH_PREFIXES = ['/login'];

function isPublic(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export const load: LayoutLoad = async ({ fetch, url }) => {
  if (isPublic(url.pathname)) {
    return { dojo: null };
  }
  if (!auth.isAuthenticated) {
    const next = encodeURIComponent(url.pathname + url.search);
    throw redirect(307, `/login?next=${next}`);
  }
  const dojo = await fetchDojo({ fetch });
  return { dojo };
};
